import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CommonResponse } from 'src/app/models/commonResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutletService {
  constructor(private http: HttpClient) { }

  getOutletById(id: string): Observable<any> {
    return this.http.get<{ data: any }>(`${environment.operational_url}outlet/${id}`)
      .pipe(map(res => res.data));
  }

  addOutlet(data: any): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.operational_url}outlet`,
      data
    );
  }

  updateOutlet(
    data: any | { isBlocked: boolean },
    id: string
  ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.operational_url}outlet/${id}`,
      data
    );
  }

  getOutletList(data: string, vendorId: string): Observable<any> {
    return this.http.get<{ data: any }>(`${environment.operational_url}outlet/vendor/${vendorId}?${data}`)
      .pipe(map(res => res.data));
  }

  deleteOutlet(id: string): Observable<number> {
    return this.http.delete<{
      statusCode: number;
    }>(`${environment.operational_url}outlet/${id}`)
      .pipe(map(res => res.statusCode));
  }

  addJobShift(data: any): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.operational_url}jobShift`,
      data
    );
  }
  getVendorJobShiftWithOutlet(vendorId: string, outletId: string): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(
      `${environment.operational_url}jobShift/vendor/${vendorId}/outlet/${outletId}`,
    );
  }

}
